import { BlocksGameRunner } from '../../model/blocks-game-runner';
import { BlocksListener } from '../blocks-listener';

export class GameRunnerService {
  public get onGameSetupStartTrigger() {
    return this.blocksGameRunner.onGameSetupStartTrigger;
  }
  public get onGameSetupCompleteTrigger() {
    return this.blocksGameRunner.onGameSetupCompleteTrigger;
  }
  public get blocksLogicActionBus$() {
    return this.blocksGameRunner.blocksLogicActionBus$;
  }
  public get currentGame() {
    return this.blocksGameRunner.currentGame;
  }

  private readonly blocksGameRunner: BlocksGameRunner;

  constructor(gameListener: BlocksListener) {
    this.blocksGameRunner = new BlocksGameRunner(gameListener);
  }

  public createLocalGame(logicVersion: number) {
    this.blocksGameRunner.startNewLocalRound(logicVersion);
  }

  public startNewRemoteRound(logicVersion: number): void {
    this.blocksGameRunner.startNewRemoteRound(logicVersion);
  }

  public startExistingRemoteRound(moves: string[], logicVersion: number): void {
    this.blocksGameRunner.startExistingRemoteRound(moves, logicVersion);
  }

  public startGame() {
    this.blocksGameRunner.clickStartGame();
  }

  public setInstantFinish() {
    this.blocksGameRunner.setInstantFinish();
  }
}
